var Captcha = function(el, options) {
  // constructor
  this.el = el
  this.options = options
  this.init()
}

Captcha.prototype.init = function() {
  if (!document.getElementById('recaptcha-script')) {
    const recaptchaSiteKey = this.el.querySelector('input[name="recaptcha3"]').value
    const body = document.getElementsByTagName('body')[0]
    const script = document.createElement('script')
    script.id = 'recaptcha-script'
    script.type = 'text/javascript'
    script.src = 'https://www.google.com/recaptcha/api.js?render=' + recaptchaSiteKey
    body.appendChild(script)
  }
}

Captcha.prototype.verify = function() {
  if (this.options.hasOwnProperty('action')) {
    const options = this.options
    const recaptchaSiteKey = this.el.querySelector('input[name="recaptcha3"]').value
    const self = this
    grecaptcha.ready(function () {
      grecaptcha.execute(recaptchaSiteKey, { action: options.action }).then(function (token) {

        /* -- ancienne méthode -- */
        /*
        const xhr = new XMLHttpRequest()
        xhr.onreadystatechange = function() {
          if (xhr.readyState === 4) { // XMLHttpRequest.DONE = 4
            if (xhr.status === 200) {
              const response = JSON.parse(xhr.responseText)
              switch (response.error) {
                case false:
                  if (options.hasOwnProperty('onSuccess'))
                    options.onSuccess()
                  break
                case true:
                  self.fallback(self.options)
                  break
              }
            } else {
              if (options.hasOwnProperty('onError'))
                options.onError()
            }
          }
        }
        //xhr.open("GET", "ajax_info.txt", true);
        xhr.open('POST', document.location.origin + '/recaptcha', true) // set true for async
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
        //xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
        //const data = 'g-recaptcha-response= + token + '&action=' + options.action
        const data = new FormData()
        data.append('g-recaptcha-response', token)
        data.append('action', options.action)
        //const data = JSON.stringify({ 'g-recaptcha-response': token, 'action': options.action })
        xhr.send(data)
        */
        /* -- fin ancienne méthode -- */

        /* -- modern JavaScript https://github.com/github/fetch must polyfill -- */
        const data = new FormData()
        data.append('g-recaptcha-response', token)
        data.append('action', options.action)
        fetch(document.location.origin + '/recaptcha', {
          method : 'POST',
          headers: new Headers({
            'X-Requested-With': 'XMLHttpRequest'
          }),
          body: data
        }).then(response => {
          if (response.status === 200) {
            response.json().then(data => {
              switch (data.error) {
                case false:
                  if (options.hasOwnProperty('onSuccess'))
                    options.onSuccess()
                  break
                case true:
                  self.fallback()
                  break
              }
            })
          } else {
            if (options.hasOwnProperty('onError'))
              options.onError()
          }
        })
        /* -- fin modern JavaScript -- */
      })
    })
  }
}

Captcha.prototype.fallback = function() {
  const self = this
  import(/* webpackChunkName: "recaptchaModal" */ '../components/recaptchaModal.js').then((module) => {
    module.recaptchaModal.init(self.options)
  })
}

export default Captcha
